import {
    GET_STATE_LOADING,    
    GET_NOVELTIES,
} from "@/views/novelties/store/types/types.js";

const getters = {
    [GET_STATE_LOADING]: state => state.loading,
    [GET_NOVELTIES]: state => state.novelties
}

export default getters;